import { defineAbilitiesFor } from 'cav-lib'
import jwtDecode from 'jwt-decode'

export const tokenStorage = {
  setItem(value) {
    try {
      localStorage.setItem(process.env.GATSBY_AUTH_TOKEN, value)
    } catch (e) {
      console.log('localStorage is not supported')
    }
  },

  getItem() {
    try {
      return localStorage.getItem(process.env.GATSBY_AUTH_TOKEN)
    } catch (e) {
      console.log('localStorage is not supported')
      return false
    }
  },

  removeItem() {
    try {
      localStorage.removeItem(process.env.GATSBY_AUTH_TOKEN)
    } catch (e) {
      console.log('localStorage is not supported')
    }
  },
}

export const getAuthData = (token) => {
  if (token) {
    const user = jwtDecode(token)
    const currentTime = new Date().getTime() / 1000
    if (currentTime > user.exp) {
      tokenStorage.removeItem()
      return { isAuthenticated: false, user: {}, ability: {} }
    } else {
      const ability = defineAbilitiesFor(user)
      return { isAuthenticated: true, user, ability }
    }
  }

  tokenStorage.removeItem()
  return { isAuthenticated: false, user: {}, ability: {} }
}
